/** 和日常质检有关的接口 **/
import request from '../index';
/** 
* PQC
* @params {string} data.batchNumber 生产批号
* @params {array} data.children 
* @params {string} data.closedLoopStatus 闭环状态
* @params {number} data.id 
* @params {number} data.inspectionFrequency 送检次数
* @params {string} data.inspectionIssues 送检问题
* @params {boolean} data.isNewDevice 是否新设备
* @params {string} data.localDate 创建日期
* @params {string} data.modelSpecifications 型号规格
* @params {string} data.notes 备注
* @params {string} data.produceOrTpc 生产模块or试产中心
* @params {number} data.productionInstructionId 
* @params {number} data.productionTaskId 
* @params {string} data.serialNumber 流水号
* @params {string} data.snNumber SN号
* @params {string} data.sourceProcess 来源工序
* @params {string} data.status 状态：合格/不合格
* @params {number} data.subordinateProcess 下级工序
* @params {string} data.type 
* @params {number} data.userId 
* @params {string} data.username 
*/

/** 
* Feedback
* @params {string} data.createTime 
* @params {string} data.feedback 
* @params {number} data.id 
* @params {string} data.image 
* @params {string} data.type 类型:日常质检/日常生产/研发话说
* @params {number} data.userId 
* @params {string} data.username 
*/

/** 
* IQC
* @params {string} data.code 编码
* @params {string} data.concessionDesc 让步接收问题描述
* @params {number} data.concessionNumber 让步数量
* @params {number} data.id 
* @params {number} data.incomingMaterialNumber 来料数量
* @params {string} data.incomingMaterialProperties 来料属性
* @params {string} data.inspectionMethod 检验方式：抽检/全检
* @params {number} data.inspectionNumber 检验数量
* @params {string} data.inspectionPersonnel 送检人员
* @params {string} data.inspector 检验人
* @params {string} data.intransigenceDesc 不能让步问题描述
* @params {number} data.intransigenceNumber 不能让步数量
* @params {string} data.localDate 日期
* @params {string} data.materialBatch 物料批号
* @params {string} data.materialType 物料类型：电子物料/结构物料/光学物料
* @params {string} data.name 名称
* @params {string} data.notes 备注
* @params {string} data.orderNumber 序号
* @params {number} data.passRate 合格率
* @params {string} data.project 项目
* @params {number} data.qualifiedNumber 合格数量
* @params {string} data.rollbackReason 回退原因
* @params {string} data.snNumber SN号
* @params {number} data.submissionNumber 送检数量
* @params {string} data.supplier 供应商名称
* @params {number} data.type 2：仓管、3：质检、-1：完成
* @params {number} data.userId 
* @params {string} data.username 
*/

/** 
* IQC质检确认
* @params {number} params.IQCId IQCId
*/
export const IQCInspectionConfirm = (params) => request.get('/api-qc/IQCInspectionConfirm', { params });

/** 
* IQC质检回退
* @params {number} params.IQCId IQCId
* @params {string} params.rollbackReason rollbackReason
*/
export const IQCInspectionRollback = (params) => request.get('/api-qc/IQCInspectionRollback', { params });

/** 
* 删除IQC记录
* @params {array} ids
*/
export const deleteIQC = (data) => request.delete('/api-qc/deleteIQC', data);

/** 
* 删除PQC
* @params {number} params.id id
*/
export const deletePQC = (id) => request.delete(`/api-qc/deletePQC?id=${id}`);

/** 
* 获得意见反馈列表
* @params {number} params.lineNum 每页显示多少条
* @params {number} params.pageNum 页码
* @params {string} params.type 类型:日常质检/日常生产
*/
export const getFeedbackList = (params) => request.get('/api-qc/getFeedbackList', { params });

/** 
* 获得IQC列表
* @params {string} params.endDate 结束时间
* @params {string} params.incomingMaterialProperties 来料属性
* @params {string} params.inspectionMethod 检验方式：抽检/全检
* @params {string} params.inspector 检验人
* @params {string} params.localDate 日期
* @params {string} params.materialType 物料类型：电子物料/结构物料/光学物料
* @params {string} params.project 项目
* @params {string} params.search search
* @params {string} params.startDate 开始时间
*/
export const getIQCList = (params) => request.get('/api-qc/getIQCList', { params });

/** 
* 获得PQC列表
* @params {string} params.endDate 结束时间
* @params {number} params.inspectionFrequency 送检次数
* @params {boolean} params.isNewDevice isNewDevice
* @params {string} params.localDate 日期
* @params {string} params.modelSpecifications 型号规格
* @params {string} params.produceOrTpc 生产或者试产
* @params {string} params.questionType 问题类型
* @params {string} params.search search
* @params {string} params.sourceProcess 来源工序
* @params {string} params.startDate 开始时间
* @params {string} params.status 状态：合格/不合格
* @params {string} params.type 工序类型
*/
export const getPQCList = (params) => request.get('/api-qc/getPQCList', { params });

/** 
* PQC合格率汇总
* @params {string} params.endDate 结束时间
* @params {string} params.localDate 日期
* @params {string} params.produceOrTpc 生产或者试产
* @params {string} params.startDate 开始时间
* @params {string} params.type 工序类型
*/
export const getPQCQualifiedSituation = (params) => request.get('/api-qc/getPQCQualifiedSituation', { params });

export const getOQCQualifiedSituation = (params) => request.get('/api-qc/getOQCQualifiedSituation', { params });

/** 
* 质检新增PQC
* @params {PQC} pqc
*/
export const insertPQC = (data) => request.post('/api-qc/insertPQC', data);

/** 
* 添加或更新意见反馈
* @params {Feedback} feedback
*/
export const saveOrUpdateFeedback = (data) => request.post('/api-qc/saveOrUpdateFeedback', data);

/** 
* 添加或更新IQC
* @params {IQC} iqc
*/
export const saveOrUpdateIQC = (data) => request.post('/api-qc/saveOrUpdateIQC', data);

/** 
* 下级工序关联
* @params {number} params.id id
* @params {array} ids
*/
export const subordinateProcessAssociation = (id, data) => request.post(`/api-qc/subordinateProcessAssociation?id=${id}`, data);

/** 
* 质检更新PQC
* @params {PQC} pqc
*/
export const updatePQC = (data) => request.put('/api-qc/updatePQC', data);

/** 
* 上传质检附件
*/
export const uploadInspectionAttachment = (data) => request.post('/api-qc/uploadInspectionAttachment', data);

/** 
* 添加or更新来料问题记录
* @params {IncomingMaterialProblem} incomingMaterialProblem
*/
export const saveIncomingMaterialProblem = (data) => request.post('/api-qc/saveIncomingMaterialProblem', data);

/** 
* 删除来料问题记录
* @params {array} ids
*/
export const deleteIncomingMaterialProblem = (data) => request.delete('/api-qc/deleteIncomingMaterialProblem', { data });

/** 
* 获取来料问题记录列表
* @params {string} params.feedbackEndDate 反馈结束日期
* @params {string} params.feedbackStartDate 反馈开始日期
* @params {string} params.incomingMaterialEndDate 来料结束日期
* @params {string} params.incomingMaterialStartDate 来料开始日期
* @params {number} params.lineNum 每页显示多少条
* @params {string} params.materialBatch 物料批号
* @params {string} params.materialCode 物料编码
* @params {string} params.materialName 物料名称
* @params {number} params.pageNum 页码
* @params {string} params.status 状态
* @params {string} params.supplierName 供应商名称
*/
export const getIncomingMaterialProblemList = (params) => request.get('/api-qc/getIncomingMaterialProblemList', { params });

/** 
* 来料问题统计
* @params {string} params.year 年度
*/
export const getIncomingMaterialProblemSummary = (params) => request.get('/api-qc/getIncomingMaterialProblemSummary', { params });

/** 
* 获取质检问题记录列表
* @params {string} params.feedbackEndDate 反馈结束日期
* @params {string} params.feedbackStartDate 反馈开始日期
* @params {number} params.lineNum 每页显示多少条
* @params {string} params.model 设备型号
* @params {number} params.pageNum 页码
* @params {string} params.problemType 问题类型
* @params {string} params.produceEndTime 生产结束时间
* @params {string} params.produceStartTime 生产开始时间
* @params {string} params.serial 机身号
* @params {string} params.status 状态
* @params {string} params.submittedProcess 送检工序
*/
export const getQualityInspectionProblemList = (params) => request.get('/api-qc/getQualityInspectionProblemList', { params });

/** 
* 质检问题统计
* @params {string} params.model 设备型号
* @params {string} params.year 年度
*/
export const getQualityInspectionProblemSummary = (params) => request.get('/api-qc/getQualityInspectionProblemSummary', { params });

/**
 * 质检问题环比
 * @params {string} params.model 设备型号
 * @params {string} params.produceOrTpc 生产或者试产
 * @params {string} params.year 年度
*/
export const qualityInspectionProblemQOQData = (params) => request.get('/api-qc/qualityInspectionProblemQOQData', { params });

/**
 * 质检问题汇总
 * @params {string} params.model 设备型号
 * @params {string} params.produceOrTpc 生产或者试产
 * @params {string} params.year 年度
*/
export const qualityInspectionProblemRate = (params) => request.get('/api-qc/qualityInspectionProblemRate', { params });

/** 
* 添加or更新质检问题记录
* @params {QualityInspectionProblem} qualityInspectionProblem
*/
export const saveQualityInspectionProblem = (data) => request.post('/api-qc/saveQualityInspectionProblem', data);

/** 
* 上传质检问题附件
*/
export const uploadQualityInspection = (data) => request.post('/api-qc/uploadQualityInspection', data);

/** 
* 删除质检问题记录
* @params {array} ids
*/
export const deleteQualityInspectionProblem = (data) => request.delete('/api-qc/deleteQualityInspectionProblem', { data });
